import React from 'react';
import useImage from './useImage';
import imagePromiseFactory from './imagePromiseFactory';
const passthroughContainer = (x) => x;
export default function Img({ decode = true, src: srcList = [], loader = null, unloader = null, container = passthroughContainer, loaderContainer = passthroughContainer, unloaderContainer = passthroughContainer, imgPromise, crossorigin, useSuspense = false, loadTimeout = null, ...imgProps // anything else will be passed to the <img> element
 }) {
    imgPromise =
        imgPromise || imagePromiseFactory({ decode, crossOrigin: crossorigin, loadTimeout });
    const { src, isLoading } = useImage({
        srcList,
        imgPromise,
        useSuspense,
    });
    // console.log({src, isLoading, resolvedSrc, useSuspense})
    // show img if loaded
    if (src)
        return container(React.createElement("img", { src: src, ...imgProps }));
    // show loader if we have one and were still trying to load image
    if (!useSuspense && isLoading)
        return loaderContainer(loader);
    // show unloader if we have one and we have no more work to do
    if (!useSuspense && unloader)
        return unloaderContainer(unloader);
    return null;
}
//# sourceMappingURL=Img.js.map